export const ROOT_COMPONENT_ID = 'events-members-root'
